import { ranking } from "@/mocks/catalog";
import SectionHeading from "@/components/feature/SectionHeading";

const trendMap = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", className: "text-accent-600" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-400" },
} as const;

export default function RankingBoard() {
  return (
    <section id="ranking" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热播榜单"
          title="跨类型高分榜单"
          description="把六个类型放在一起横向对比，看看不同类型里哪些作品同时具备口碑与热度。榜单仅用于本页参考，不涉及外部数据来源。"
        />

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200">
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-500 md:grid">
            <span className="col-span-1">排名</span>
            <span className="col-span-5">片名</span>
            <span className="col-span-2">类型</span>
            <span className="col-span-2">评分</span>
            <span className="col-span-2 text-right">热度趋势</span>
          </div>

          <ul className="divide-y divide-background-200 bg-background-50">
            {ranking.map((item) => {
              const trend = trendMap[item.trend];
              return (
                <li
                  key={item.rank}
                  className="grid grid-cols-12 items-center gap-4 px-5 py-4 transition-colors hover:bg-primary-50"
                >
                  <span className="col-span-3 flex items-center md:col-span-1">
                    <span
                      className={`font-heading text-lg font-bold ${
                        item.rank <= 3 ? "text-primary-600" : "text-foreground-400"
                      }`}
                    >
                      {item.rank}
                    </span>
                  </span>
                  <span className="col-span-9 font-heading text-base font-semibold text-foreground-950 md:col-span-5">
                    {item.title}
                  </span>
                  <span className="col-span-6 md:col-span-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                      {item.genre}
                    </span>
                  </span>
                  <span className="col-span-6 flex items-center gap-1 md:col-span-2">
                    <i className="ri-star-fill text-accent-500"></i>
                    <span className="font-heading text-sm font-semibold text-foreground-900">
                      {item.rating.toFixed(1)}
                    </span>
                  </span>
                  <span className="col-span-12 flex items-center gap-2 md:col-span-2 md:justify-end">
                    <i className={`${trend.icon} ${trend.className}`}></i>
                    <span className="text-xs text-foreground-500">{item.heat}</span>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}